import { render, staticRenderFns } from "./ColorPickerInput.vue?vue&type=template&id=77ab97a0&scoped=true&"
import script from "./ColorPickerInput.vue?vue&type=script&lang=js&"
export * from "./ColorPickerInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerInput.vue?vue&type=style&index=0&id=77ab97a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ab97a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VCardSubtitle,VColorPicker})
